module.exports = __webpack_public_path__ + "img/T5-C-rc_8.b6cda030.png";